import { createContext } from 'react';

import { FinancialInfoProps } from 'components/modals/AssignmentDataModal/FinancialInfo';

export type FinancialSchedulerType = Pick<
  FinancialInfoProps,
  | 'predefinedFinancialSchedulerValues'
  | 'workSiteWorkLocation'
  | 'w2InfoByWorkSiteWorkLocation'
> & {
  isW2Assignment?: boolean;
  isAdmin?: boolean;
};

const initialFinancialSchedulerContext: FinancialSchedulerType = {
  predefinedFinancialSchedulerValues: undefined,
  workSiteWorkLocation: null,
  w2InfoByWorkSiteWorkLocation: undefined,
  isW2Assignment: undefined,
  isAdmin: undefined,
};

const FinancialSchedulerContext = createContext(
  initialFinancialSchedulerContext,
);

export default FinancialSchedulerContext;
